export default "__VITE_ASSET__GHMiOX74__"